class Application {
    id = null;
    vacancy_id = null;
    seafarer_id = null;
    maritime_object_id = null;
    rank_id = null;
    seniority = null;
    application_status_id = 1;
    status_notes = '';
    sign_on_date = null;
    created_placement = false;
    gdpr_edit_lock = false;
    name = '';
    surname = '';
    email = '';
    phone = '';
    nationality_id = null;
    seafarer_book = '';
    candidate_resume = {
        name: '',
        link: '',
        original_name: '',
        upload_id: null,
	};

	available_date = null;
	date_of_birth = null;
	oib = '';
	country_of_residency_id = null;
	place_of_birth = '';
	gender_id = null;
	marital_status_id = null;
	account_currency_id = null;
	street_name_and_number = '';
	city = '';
	post_code = '';
	country_id = null;
	airport_id = null;
	emergency_contact_name = '';
	emergency_contact_relationship_id = null;
	emergency_contact_street_name_and_number = '';
	emergency_contact_city = '';
	emergency_contact_post_code = '';
	emergency_contact_country_id = null;
	contact_number = '';
	contact_email = '';


    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Application;
